import { useState } from "react";
import Requester from "../helpers/Requester";
import App from "../layouts/app";
import clsx from "clsx";
import CreateCompetitionForm from "../components/CreateCompetitionForm";
import { router } from "@inertiajs/react";

export default function CompetitionEdit({ competition }) {

    const saveCompetition = (data: any) => {
        const requester = new Requester();

        requester.post(requester.getUrl(`api/competitions/${competition.id}`), data).then((response) => {
            router.visit(`/competitions/${competition.id}`);
        }).catch((error) => {
            alert("Error saving competition: " + error.message);
        })
    }

    return (
        <App>
            <div className="w-full">
                <div className="max-w-dasha mx-auto py-20 pt-0 flex flex-col space-y-7">
                    <CreateCompetitionForm onSubmit={saveCompetition} competition={competition} />
                </div >
            </div >
        </App >
    )
}